<!--&lt;!&ndash; Use preprocessors via the lang attribute! e.g. <template lang="pug"> &ndash;&gt;-->
<!--<template>-->
<!--&lt;!&ndash;    <div class="modal-3d" v-if="showModal3dFlag">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="modal-3d-content">&ndash;&gt;-->
<!--&lt;!&ndash;            <span class="close-modal3d" @click="closeModal3d">&times;</span>&ndash;&gt;-->
<!--            <canvas v-if="showModal3dFlag" id="three-canvas"></canvas>-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--</template>-->
<!--<script>-->
<!--import * as THREE from 'three'-->
<!--import {GLTFLoader} from 'three/addons/loaders/GLTFLoader.js';-->
<!--import {OrbitControls} from 'three/addons/controls/OrbitControls.js';-->
<!--import {Vector3} from "three";-->

<!--export default {-->
<!--    data() {-->
<!--        return {-->
<!--            modelColor: '#ffffff',-->
<!--            fileInfo: null,-->
<!--            model: null,-->
<!--        };-->
<!--    },-->
<!--    props: {-->
<!--        showModal3dFlag: {-->
<!--            type: Boolean,-->
<!--            required: true,-->
<!--        },-->
<!--        modelColor: {-->
<!--            type: String,-->
<!--        },-->
<!--        modelObjPath: {-->
<!--            type: String,-->
<!--            required: true-->
<!--        },-->
<!--    },-->
<!--    mounted() {-->
<!--        this.loadScene();-->
<!--        window.addEventListener("click", this.onClickOutsode3d);-->
<!--    },-->
<!--    methods: {-->

<!--        onClickOutsode3d(e) {-->
<!--            if (e.target.localName == ".modal-3d") {-->
<!--                this.showModal3dFlag = false;-->
<!--                this.$emit("close");-->
<!--            } else {-->
<!--            }-->
<!--        },-->
<!--        closeModal3d() {-->
<!--            this.$emit("close");-->
<!--        },-->
<!--        loadScene() {-->
<!--            let vm = this;-->
<!--            const scene = new THREE.Scene();-->
<!--            const size = {-->
<!--                width: 600,-->
<!--                height: 600,-->
<!--            };-->

<!--            const aspect = 600 / 600;-->
<!--            const camera = new THREE.PerspectiveCamera(10, aspect);-->
<!--            camera.position.z = 200;-->
<!--            camera.position.y = 100;-->
<!--            camera.position.x = 200;-->

<!--            const lightColor = 0xffffff;-->

<!--            const ambientLight = new THREE.AmbientLight(lightColor, 0.5);-->
<!--            scene.add(ambientLight);-->

<!--            const directionalLight = new THREE.DirectionalLight(lightColor, 1);-->
<!--            directionalLight.position.set(0, 10, 0);-->
<!--            directionalLight.target.position.set(-5, 0, 0);-->
<!--            scene.add(directionalLight);-->
<!--            scene.add(directionalLight.target);-->
<!--            scene.background = new THREE.Color(0xfcfbfb);-->

<!--            const grid = new THREE.GridHelper(600, 20);-->
<!--            scene.add(grid);-->

<!--            const threeCanvas = document.getElementById('three-canvas');-->

<!--            if (threeCanvas) {-->
<!--                const renderer = new THREE.WebGLRenderer({-->
<!--                    canvas: threeCanvas,-->
<!--                    alpha: true,-->
<!--                });-->
<!--                renderer.setSize(size.width, size.height);-->
<!--                renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));-->
<!--                const material = new THREE.MeshPhongMaterial({color: 0xff0000});-->
<!--                const controls = new OrbitControls(camera, threeCanvas);-->
<!--                controls.enableDamping = true;-->
<!--                controls.target.set(-2, 0, 0);-->

<!--                const animate = () => {-->
<!--                    controls.update();-->
<!--                    renderer.render(scene, camera);-->
<!--                    requestAnimationFrame(animate);-->
<!--                };-->


<!--                const loader = new GLTFLoader().setPath(window.location.origin);-->
<!--                loader.load(vm.modelObjPath,-->
<!--                    function (gltf) {-->

<!--                        const addedModel = gltf.scene;-->
<!--                        vm.model = addedModel;-->
<!--                        addedModel.position.add(new Vector3(0, 0, 0));-->
<!--                        const geometry = new THREE.BufferGeometry();-->
<!--                        // geometry.center();-->
<!--                        scene.add(addedModel);-->

<!--                        // Set the color of the model (you can use any valid THREE.Color value)-->
<!--                        const color = new THREE.Color('#ffffff'); // red color-->
<!--                        addedModel.traverse((child) => {-->
<!--                            if (child.isMesh) {-->
<!--                                child.material.color = color;-->
<!--                            }-->
<!--                        });-->
<!--                    },-->
<!--                    (xhr) => {-->
<!--                        console.log((xhr.loaded / xhr.total) * 100 + '% loaded')-->
<!--                    },-->
<!--                    (error) => {-->
<!--                        console.log(error)-->
<!--                    }-->
<!--                )-->
<!--                animate();-->
<!--            }-->
<!--        },-->
<!--        changeModelColor(color) {-->
<!--            let vm = this;-->

<!--            const colorTree = new THREE.Color(color); // red color-->
<!--            vm.model.traverse((child) => {-->
<!--                if (child.isMesh) {-->
<!--                    child.material.color = colorTree;-->
<!--                }-->
<!--            });-->
<!--            // vm.renderScene();-->
<!--        },-->
<!--    },-->
<!--    watch: {-->
<!--        // modelColor(newColor, oldColor) {-->
<!--        //     this.changeModelColor(newColor);-->
<!--        // }-->
<!--    }-->
<!--};-->
<!--</script>-->

<!--&lt;!&ndash; Use preprocessors via the lang attribute! e.g. <style lang="scss"> &ndash;&gt;-->
<!--<style scoped>-->
<!--a,-->
<!--button {-->
<!--    color: #4fc08d;-->
<!--}-->

<!--button {-->
<!--    background: none;-->
<!--    border: solid 1px;-->
<!--    border-radius: 2em;-->
<!--    font: inherit;-->
<!--    padding: 0.75em 2em;-->
<!--}-->

<!--.three-canvas {-->
<!--    width: 100%;-->
<!--    height: 100%;-->
<!--}-->

<!--.modal-3d-content {-->
<!--    position: absolute;-->
<!--    width: 50%;-->
<!--    top: 50%;-->
<!--    left: 50%;-->
<!--    margin-right: -50%;-->
<!--    transform: translate(-50%, -50%);-->
<!--}-->

<!--.modal-3d {-->
<!--    position: fixed;-->
<!--    border: 1px solid gray;-->
<!--    background-color: #000c;-->
<!--    bottom: 0;-->
<!--    right: 0;-->
<!--    top: 0;-->
<!--    left: 0;-->
<!--    z-index: 10;-->

<!--}-->

<!--.close-modal3d {-->
<!--    color: #ccc;-->
<!--    float: right;-->
<!--    font-size: 58px;-->
<!--    font-weight: bold;-->
<!--    cursor: pointer;-->
<!--    position: absolute;-->
<!--    right: 2rem;-->
<!--}-->
<!--</style>-->
<!-- Use preprocessors via the lang attribute! e.g. <template lang="pug"> -->
<template>
    <canvas class="three-canvas"></canvas>
</template>
<script>
import * as THREE from 'three'
import {GLTFLoader} from 'three/addons/loaders/GLTFLoader.js';
import {OrbitControls} from 'three/addons/controls/OrbitControls.js';
import {Vector3} from "three";

export default {
    data() {
        return {
            modelColor: '#ffffff',
            fileInfo: null,
            model: null,
        };
    },
    props: {
        modelColor: {
            type: String,
            // required: true
        },
        indexInArrOfModels: {
            // type: Array,
            type: String,
            required: true
        },

        modelObjPath: {
            // type: Array,
            type: String,
            required: true
        },
    },
    mounted() {
        this.loadScene();
    },
    methods: {
        loadScene() {
            let vm = this;
            const scene = new THREE.Scene();
            const size = {
                width: 600,
                height: 600,
            };

            const aspect = 600 / 600;
            const camera = new THREE.PerspectiveCamera(10, aspect);
            camera.position.z = 200;
            camera.position.y = 100;
            camera.position.x = 200;

            const lightColor = 0xffffff;

            const ambientLight = new THREE.AmbientLight(lightColor, 0.5);
            scene.add(ambientLight);

            const directionalLight = new THREE.DirectionalLight(lightColor, 1);
            directionalLight.position.set(0, 10, 0);
            directionalLight.target.position.set(-5, 0, 0);
            scene.add(directionalLight);
            scene.add(directionalLight.target);
            scene.background = new THREE.Color(0xfcfbfb);

            const grid = new THREE.GridHelper(600, 20);
            scene.add(grid);

            const threeCanvas = document.getElementsByClassName('three-canvas')[vm.indexInArrOfModels];

            if (threeCanvas) {
                const renderer = new THREE.WebGLRenderer({
                    canvas: threeCanvas,
                    alpha: true,
                });
                renderer.setSize(size.width, size.height);
                renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
                const material = new THREE.MeshPhongMaterial({color: 0xff0000});
                const controls = new OrbitControls(camera, threeCanvas);
                controls.enableDamping = true;
                controls.target.set(-2, 0, 0);

                const animate = () => {
                    controls.update();
                    renderer.render(scene, camera);
                    requestAnimationFrame(animate);
                };


                const loader = new GLTFLoader().setPath(window.location.origin);
                loader.load(vm.modelObjPath,
                    function (gltf) {

                        const addedModel = gltf.scene;
                        vm.model = addedModel;
                        addedModel.position.add(new Vector3(0,0,0));
                        const geometry = new THREE.BufferGeometry();
                        // geometry.center();
                        scene.add(addedModel);

                        // Set the color of the model (you can use any valid THREE.Color value)
                        const color = new THREE.Color('#ffffff'); // red color
                        addedModel.traverse((child) => {
                            if (child.isMesh) {
                                child.material.color = color;
                            }
                        });
                    },
                    (xhr) => {
                        // console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
                    },
                    (error) => {
                        console.log(error)
                    }
                )
                animate();
            }
        },
        changeModelColor(color) {
            let vm = this;

            const colorTree = new THREE.Color(color); // red color
            vm.model.traverse((child) => {
                if (child.isMesh) {
                    child.material.color = colorTree;
                }
            });
            // vm.renderScene();
        },
    },
    watch: {
        modelColor(newColor, oldColor) {
            this.changeModelColor(newColor);
        }
    }
};
</script>

<!-- Use preprocessors via the lang attribute! e.g. <style lang="scss"> -->
<style>

</style>
